import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, Grid, Container } from "@mui/material";
import { styles } from "../../components/formStyles";
import {
  adminEditRequest,
  authResetState,
} from "../../../redux/auth/AuthAction";
import { LoginValue } from "../../../redux/storeValues/StoreValuesAction";
import CustomButton from "../../constant/commonButton";
import CommonDialog from "../../notification/ErrorDialogbox";
import { mapBackendMessage } from "../../notification/BackendMessage";
import "../../../style/style.css";
import ReusableFormFields from "../../constant/reusableFormFields";
import { APP_LINK } from "../../global/MenuItems";
import { useNavigate } from "react-router-dom";

const EditAdmin = () => {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    setError,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [editTriggered, setEditTriggered] = useState(null);
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(true);

  const AdminList = useSelector((state) => state?.values?.loginValues?.[0]);

  const editAdminState = useSelector((state) => state?.auth?.editAdmin);
  const inputFields = [
    {
      name: "first_name",
      label: "First Name",
    },
    {
      name: "last_name",
      label: "Last Name",
    },
    {
      name: "email",
      label: "Email Address",
      rules: {
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email format",
        },
      },
    },
    {
      name: "contact",
      label: "Phone No",
      rules: {
        required: "Phone No is required",
        pattern: {
          value: /^\d{8,}$/,
          message: "Invalid Phone Number",
        },
      },
    },
  ];

  useEffect(() => {
    if (AdminList) {
      setValue("id", AdminList?.id);
      setValue("first_name", AdminList?.first_name);
      setValue("last_name", AdminList?.last_name);
      setValue("email", AdminList?.email);
      setValue("contact", AdminList?.contact);
      setValue("user_type", AdminList?.user_type);
    }
  }, [AdminList, setValue]);

  const onSubmit = (data) => {
    const editRequestData = {
      user_type: AdminList?.user_type,
      ...data,
    };
    setEditTriggered(true);
    dispatch(adminEditRequest(editRequestData));
  };

  const handleEditWholesalerResponse = () => {
    if (editAdminState?.error) {
      const errorFields = editAdminState?.errorFields || {};
      const errorMessages = editAdminState?.errormessage || {};

      if (Object.keys(errorFields).length > 0) {
        Object.keys(errorFields).forEach((field) => {
          setError(field, {
            type: "manual",
            message: errorFields[field],
          });
        });
      } else if (typeof errorMessages === "string") {
        const lowerMsg = errorMessages.toLowerCase();
        if (
          lowerMsg.includes(
            "this mobile number already added in different email id"
          ) ||
          lowerMsg.includes(
            "this mobile number already added in diffrent email id"
          )
        ) {
          setError("contact", {
            type: "manual",
            message: errorMessages,
          });
        } else {
          setError("email", {
            type: "manual",
            message: errorMessages,
          });
        }
      } else {
        const customMessage = mapBackendMessage(
          editAdminState?.errormessage ||
            "An error occurred while updating the wholesaler."
        );
        setDialogMessage(customMessage);
        setIsSuccess(false);
        setDialogOpen(true);
      }
    } else if (editAdminState?.success) {
      setDialogMessage("Profile updated successfully");
      setIsSuccess(true);
      setDialogOpen(true);

      if (editAdminState?.updatedAdminData) {
        dispatch(LoginValue(editAdminState.updatedAdminData));
      }

      dispatch(authResetState());
    }
  };

  useEffect(() => {
    if (editTriggered) {
      handleEditWholesalerResponse();
    }
  }, [editTriggered, editAdminState]);

  const handleCancel = () => {
    navigate(APP_LINK.DASHBOARD);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            <Box>
              <Typography
                variant="h5"
                gutterBottom
                sx={styles.title}
                className="headingTable"
              >
                <h1> Edit Profile </h1>
              </Typography>
            </Box>
            <ReusableFormFields
              inputFields={inputFields}
              control={control}
              errors={errors}
              register={register}
            />

            {/* Submit Button */}
            <Box sx={styles.submitGap}>
              <Grid container spacing={2} item xs={12}>
                <Grid item xs={6}>
                  <CustomButton
                    text="Submit"
                    size="medium"
                    type="submit"
                    buttonStyle="StyledButton"
                    disabled={editAdminState?.inProgress}
                    loading={editAdminState?.inProgress}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomButton
                    text="Cancel"
                    variant="contained"
                    size="medium"
                    fullWidth
                    buttonStyle="style1"
                    onClick={handleCancel}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </form>

      {/* Dialog */}
      <CommonDialog
        open={dialogOpen}
        isSuccess={isSuccess}
        onClose={handleDialogClose}
        messageSuccess={dialogMessage}
        messageError={dialogMessage}
      />
    </Container>
  );
};

export default EditAdmin;
